import { render } from "./NormalPage.vue?vue&type=template&id=74fd5b58"
import script from "./NormalPage.vue?vue&type=script&lang=js"
export * from "./NormalPage.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__